/* src/app/views/smart-filters/components/smart-filter-card-row/smart-filter-category-card/smart-filter-category-card.component.scss */
.bs-light {
  font-family: poppins, sans-serif;
  font-weight: 300;
  font-style: normal;
}
.bs-italic {
  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: italic;
}
.bs-regular {
  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: normal;
}
.bs-medium {
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-style: normal;
}
.bs-medium-italic {
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-style: italic;
}
.bs-bold-italic {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-style: italic;
}
.bs-semi-bold {
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-style: normal;
}
.bs-semi-bold-italic {
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-style: italic;
}
.bs-bold {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-style: normal;
}
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.smart-filter-category-card {
  position: relative;
  display: flex;
  word-wrap: break-word;
  background-color: #f2f2f2;
  border-radius: 0.625rem;
  height: 3.5rem;
  min-width: 12rem;
  padding: 0.75rem;
  cursor: pointer;
  justify-content: space-between;
}
.image-container {
  height: 3.5rem;
  width: 3.5rem;
  margin-left: -0.79rem;
  border-radius: 0.625rem;
}
.content-container {
  display: flex;
  align-items: center;
}
.text-container {
  display: block;
}
.category-name {
  margin-bottom: -0.25rem;
  font-size: 0.875rem;
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-style: normal;
}
.category-subtext {
  color: #737680;
  font-size: 0.75rem;
  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: normal;
}
/*# sourceMappingURL=smart-filter-category-card.component.css.map */
